export default __webpack_public_path__ + "static/media/stratzy-partner.7af3665b.svg";